/**
 * Gets called by js/tinyMce/plugins/specialloops/specialloops.plugin.js
 *
 * @param editor
 * @param url
 * @returns {{getMetadata: getMetadata}}
 */
function tinymce_special_loops_init(editor, url) {
    var $ = jQuery.noConflict();
    // Add a button that opens a window
    editor.addButton('specialloops', {
        text: 'Loop',
        icon: false,
        onclick: function() {
            open_loop_form(editor);
        }
    });

    // Adds a menu item to the tools menu
    editor.addMenuItem('specialloops', {
        text: 'Specialloops plugin',
        context: 'tools',
        onclick: function() {
            // Open window with a specific url
            editor.windowManager.open({
                title: 'TinyMCE site',
                url: 'https://www.tinymce.com',
                width: 800,
                height: 600,
                buttons: [{
                    text: 'Close',
                    onclick: 'close'
                }]
            });
        }
    });

    editor.on('init', function (e) {
        init_changeable_loops(editor);
    });
    editor.on('setContent', function (e) {
        init_changeable_loops(editor);
    });
    editor.on('paste', function (e) {
        init_changeable_loops(editor);
    });

    function init_changeable_loops(editor) {
        $(editor.getDoc()).contents().find('special-loop').unbind('click').click(function() {
            var replace_content_id = $(this).parent().attr('id');
            var args = $(this).attr('data-loop').split(' as ');
            var html = $(this).html();
            var data = {
                parent: args[0],
                child: args[1],
                content: html
            };
            open_loop_form(editor, data, replace_content_id);
        });
    }
    function open_loop_form(editor, data, replace_content_id) {
        var new_loop = data == undefined;
        var placeholder_id;
        if(new_loop) {
            data = {};
            replace_content_id = 'loop-'+(new Date().getTime());
            placeholder_id = 'insert-here-'+(new Date().getTime());
            editor.insertContent('<span id="'+placeholder_id+'">&nbsp;</span>');
        }
        var parent_editor_id = editor.id;
        $.squdeAjaxPopup({
            url: '/tinymce/get_loop_form',
            data: data,
            onOpen: function (elm, popup) {

                elm.find('form').submit(function(e) {
                    var f = $(this);
                    var data = f.serializeJSON();

                    data.content = tinymce.get('content').getContent();

                    var just_close = false;
                    for(var key in data) {
                        if(data[key].length == 0) {
                            just_close = true;
                        }
                    }
                    /*
                    <div><special-loop data-loop="d as ff">loopmffefdfdfd<br />fdfdfdfd<br /></special-loop></div>

                    <p>Beste $contact.messageName,</p>
                    <p>U kunt nu inloggen op $url met uw emailadres en het volgende wachtwoord.</p>
                    <div><special-loop data-loop="d as ff">loopmffefdfdfd<br />fdfdfdfd<br /></special-loop></div>
                    <div><special-loop data-loop="d as ff">loopmffefdfdfd<br />fdfdfdfd<br /></special-loop></div>
                    <div style="margin: 0 0 1rem 0; padding: 1rem; border: 1px solid rgba(10, 10, 10, 0.25); border-radius: 0; position: relative; background-color: rgba(214, 253, 239, 0.999); text-align: center;">$password_html</div>


                     */

                    if(!just_close) {
                        var parent = tinymce.get(parent_editor_id);

                        var new_content = '<div id="'+replace_content_id+'"><special-loop data-loop="'+data.parent+' as '+data.child+'">'+data.content+'</special-loop></div>';
                        if(new_loop) {
                            var newNode = parent.dom.select('span#' + placeholder_id);
                            parent.selection.select(newNode[0]);
                            parent.insertContent(new_content);
                        } else {
                            new_content = $($.parseHTML(new_content));
                            var c = parent.getContent();
                            var html = $($.parseHTML('<div>'+c+'</div>'));
                            html.find('#'+replace_content_id).html(new_content.html());
                            parent.setContent(html.html());
                        }
                        setTimeout(function() {
                            init_changeable_loops(parent);
                        },500);
                    }


                    popup.close();

                    return false;
                });
            },
            onClose: function() {
                if(placeholder_id) {
                    var parent = tinymce.get(parent_editor_id);
                    var c = parent.getContent();
                    var html = $($.parseHTML('<div>'+c+'</div>'));
                    html.find('#'+placeholder_id).remove();
                    parent.setContent(html.html());
                }
            }
        });
    }

    return {
        getMetadata: function () {
            return  {
                name: "Specialloops plugin",
                url: "http://specialloopsplugindocsurl.com"
            };
        }
    };
}